export interface Config {
    auth: {
        region: 'us-east-1';
        userPoolId: string;
        userPoolWebClientId: string;
        oauth: {
            domain: string;
            scope: string[];
            redirectSignIn: string;
            redirectSignOut: string;
            responseType: 'code';
        };
    };
    api: {
        baseUrl: string;
    };
    media: {
        profileImagesBucket: string;
        communityImagesBucket: string;
        theSourceMediaBucket: string;
        forumMediaBucket: string;
    };
    artist: {
        bandsInTownId: string;
        instagram: string;
        name: string;
        soundcloud: string;
        spotifyId: string;
        x: string;
        youTubeId: string;
    };
}

const config: Record<string, Config> = {
    local: {
        auth: {
            region: 'us-east-1',
            userPoolId: 'us-east-1_KNCoUsuou',
            userPoolWebClientId: '1fimbd8j3n112emebtd2f5romj',
            oauth: {
                domain: 'authlocal.abstract-the-artist.com',
                scope: ['profile', 'email', 'openid'],
                redirectSignIn: 'http://localhost:3000',
                redirectSignOut: 'http://localhost:3000',
                responseType: 'code',
            },
        },
        api: {
            baseUrl: 'https://zu151flgs4.execute-api.us-east-1.amazonaws.com',
        },
        media: {
            profileImagesBucket: 'https://d7lz0ybuwe6wm.cloudfront.net',
            communityImagesBucket: 'https://d2z9ox4hlqm8sj.cloudfront.net',
            theSourceMediaBucket: 'https://d1tbsuikyxmg4c.cloudfront.net',
            forumMediaBucket: 'https://d2vm9y26poc4od.cloudfront.net',
        },
        artist: {
            bandsInTownId: '102544-abstract',
            instagram: 'abstract307',
            name: 'Abstract',
            soundcloud: 'abstract-official',
            spotifyId: '7lkYBcrLM4JmVgeha1xNl6',
            x: 'thetrueabstract',
            youTubeId: 'UCwP3cAr798B69rULA_w_SdA',
        },
    },
    dev: {
        auth: {
            region: 'us-east-1',
            userPoolId: 'us-east-1_s2IIUiNLz',
            userPoolWebClientId: '1rqe285angfjcgosju7k9pfqn4',
            oauth: {
                domain: 'authdev.abstract-the-artist.com',
                scope: ['profile', 'email', 'openid'],
                redirectSignIn: 'https://dev.abstract-the-artist.com',
                redirectSignOut: 'https://dev.abstract-the-artist.com',
                responseType: 'code',
            },
        },
        api: {
            baseUrl: 'https://9n5q7x482d.execute-api.us-east-1.amazonaws.com',
        },
        media: {
            profileImagesBucket: 'https://d12vnjjwmvyfk2.cloudfront.net',
            communityImagesBucket: 'https://d373swxowdtfh5.cloudfront.net',
            theSourceMediaBucket: 'https://dotbtpiad0rhr.cloudfront.net',
            forumMediaBucket: 'https://d34o0hz06pn73a.cloudfront.net',
        },
        artist: {
            bandsInTownId: '102544-abstract',
            instagram: 'abstract307',
            name: 'Abstract',
            soundcloud: 'abstract-official',
            spotifyId: '7lkYBcrLM4JmVgeha1xNl6',
            x: 'thetrueabstract',
            youTubeId: 'UCwP3cAr798B69rULA_w_SdA',
        },
    },

    prod: {
        auth: {
            region: 'us-east-1',
            userPoolId: 'us-east-1_WqdNeIZm0',
            userPoolWebClientId: '4r9497km119edsj2g10psn9v8j',
            oauth: {
                domain: 'auth.abstract-the-artist.com',
                scope: ['profile', 'email', 'openid'],
                redirectSignIn: 'https://www.abstract-the-artist.com',
                redirectSignOut: 'https://www.abstract-the-artist.com',
                responseType: 'code',
            },
        },
        api: {
            baseUrl: 'https://qssnrvd1wg.execute-api.us-east-1.amazonaws.com',
        },
        media: {
            profileImagesBucket: 'https://d16gnbz2adg8pi.cloudfront.net',
            communityImagesBucket: 'https://dze6ss3m3sbgd.cloudfront.net',
            theSourceMediaBucket: 'https://dzkkq54w8d6zq.cloudfront.net',
            forumMediaBucket: 'https://d1y65i7qxrbsn6.cloudfront.net',
        },
        artist: {
            bandsInTownId: '102544-abstract',
            instagram: 'abstract307',
            name: 'Abstract',
            soundcloud: 'abstract-official',
            spotifyId: '7lkYBcrLM4JmVgeha1xNl6',
            x: 'thetrueabstract',
            youTubeId: 'UCwP3cAr798B69rULA_w_SdA',
        },
    },
};

export function getConfig(): Config {
    return config[process.env.REACT_APP_ENV || 'local'];
}
